import { UserRoleCodes } from '@/types'

import { checkRights } from '@/helpers'

export default [
  {
    path: 'marketing/coupons',
    name: 'manager-marketing-coupons',
    component: () =>
      import('../../../views/Manager/Marketing/ManagerMarketingCoupons.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'marketing/ticker',
    name: 'manager-marketing-ticker',
    component: () =>
      import('../../../views/Manager/Marketing/ManagerMarketingTicker.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'marketing/popup',
    name: 'manager-marketing-popup',
    component: () =>
      import('../../../views/Manager/Marketing/ManagerMarketingPopup.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'marketing/subscription',
    name: 'manager-marketing-subscription',
    component: () =>
      import(
        '../../../views/Manager/Marketing/ManagerMarketingSubscription.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'marketing/products',
    name: 'manager-marketing-products',
    component: () =>
      import('../../../views/Manager/Marketing/ManagerMarketingProducts.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
]
